import GridItem from "./related-news-item.component.vue";

export default GridItem;
